// src/utils/launchConfetti.js
import confetti from 'canvas-confetti';

export function launchGrandConfetti() {
  // A multi-burst confetti for a big celebration
  confetti({
    particleCount: 200,
    spread: 90,
    origin: { y: 0.6 },
  });
  setTimeout(() => {
    confetti({
      particleCount: 200,
      spread: 120,
      origin: { x: 1, y: 0.6 },
    });
  }, 400);
  setTimeout(() => {
    confetti({
      particleCount: 200,
      spread: 120,
      origin: { x: 0, y: 0.6 },
    });
  }, 800);
}
